import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { cn } from '../../../utils/tailwind';
import { IconArrowDown } from '../icons/arrow-down';
import { IconArrowUp } from '../icons/arrow-up';

type InfoBoxType = {
    name: string;
    more?: string;
    description?: React.ReactNode;
    extraContent?: React.ReactNode;
    image?: string;
    dark?: boolean;
};
export const InfoBox: React.FC<InfoBoxType> = ({ name, more, description, extraContent, image, dark = false }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [isOpened, setIsOpened] = useState<boolean>(false);

    return (
        <div
            className="mb-medium rounded-medium border border-solid p-small shadow-strong md:p-[3.2rem] xl:p-[6.4rem]"
            style={
                {
                    borderColor: dark ? theme.palette.color.secondary.main : theme.palette.common.border,
                    backgroundColor: dark ? theme.palette.color.secondary.main : theme.palette.background.body,
                    color: dark ? theme.palette.common.textInverse : theme.palette.common.text,
                    backgroundImage: image ? `url(${image})` : undefined,
                    backgroundRepeat: image ? 'no-repeat' : undefined,
                    backgroundPosition: image ? '100% 0' : undefined,
                } as React.CSSProperties
            }
        >
            <div
                className={cn(
                    'flex flex-col gap-small pr-large lg:gap-small lg:pr-0',
                    description ? 'lg:grid lg:grid-cols-[1fr]' : 'lg:grid lg:grid-cols-[1fr_1.6fr_1fr]',
                )}
            >
                <div className="flex flex-col">
                    <div className="mb-xsmall text-[2.4rem] font-bold leading-[2.8rem] md:text-[3.2rem] md:leading-[3.6rem]">
                        {name}
                    </div>
                    {more && (
                        <div
                            onClick={() => setIsOpened(!isOpened)}
                            className="flex cursor-pointer items-center gap-xsmall font-bold text-[#6A6FF9]"
                        >
                            {isOpened ? <IconArrowUp /> : <IconArrowDown />}

                            {isOpened ? t('infoBox.close') : more}
                        </div>
                    )}
                </div>
                {description ? (
                    <div className="text-[1.6rem] leading-[2.2rem] md:text-[2.2rem] md:leading-[2.8rem]">
                        {description}
                    </div>
                ) : null}
            </div>
            {extraContent && isOpened && <div className="pt-medium lg:pr-[22rem] xl:pr-0">{extraContent}</div>}
        </div>
    );
};
